import keymirror from 'keymirror';

export default keymirror({
  left: null,
  center: null,
  right: null,
});
